export const OPEN_NEW_PROJECT_FORM = "@NEW_PROJECT_BUTTON/OPEN_NEW_PROJECT_FORM";
export const CLOSE_NEW_PROJECT_FORM = "@NEW_PROJECT_BUTTON/CLOSE_NEW_PROJECT_FORM";

export const actionCreators = {
    openNewProjectForm: () => ({ type: OPEN_NEW_PROJECT_FORM}),
    closeNewProjectForm: () => ({ type: CLOSE_NEW_PROJECT_FORM}),
};
